/**
 * Splits out the variables part of a storeFieldName and then JSON.parses it.
 * type T is the query variables used for the cached query.
 *
 * @param storeFieldName The storeFieldName value
 * @returns json The Object resulting from JSON.parsing the variables
 */
export function parseStoreFieldName<T>(storeFieldName: string): T | undefined {
  let json: T;

  try {
    const variablesPart = storeFieldName.substring(
      storeFieldName.indexOf(':') + 1
    );

    json = JSON.parse(variablesPart);
  } catch (e) {
    return undefined;
  }

  return json;
}
